// import React, { useState, useEffect } from "react";
// import Table from "../../../../components/ACS-Dashboard/ACS-Blocks/Table";
// import Button from "../../../../components/ACS-Dashboard/ACS-Blocks/Button";
// import {sampleEstimatedChargesData} from "./sampleInvoiceData";
// import GlobalPagination  from "../../../../components/ACS-Dashboard/ACS-Blocks/GlobalPagination";

// const EstimatedChargesTab = ({searchQuery,onUpdateCount}) => {
//     const headers = [
//         'Charge ID','Shipping ID', 'Description', 'Charge Type', 'Amount', 'Due Date', 'Status'
//     ];

//     const [activeTab, setActiveTab] = useState('detention');

//     const [currentPage, setCurrentPage] = useState(1);
//     const [itemsPerPage, setItemsPerPage] = useState(10);
//     const [filteredCharges, setFilteredCharges] = useState(sampleEstimatedChargesData);
//     const [EstimatedCharge, setEstimatedCharge] = useState([]);


//     //
//     useEffect(() => {
//         setEstimatedCharge(sampleEstimatedChargesData);
//         setFilteredCharges(sampleEstimatedChargesData);
//         if(onUpdateCount){
//             onUpdateCount(sampleEstimatedChargesData.length);
//         }
//     }, []);

//     useEffect(() => {
//         const filteredCharges = EstimatedCharge.filter(charge =>
//             (activeTab === 'detention' && charge.chargeType.toLowerCase() === 'detention') ||
//             (activeTab === 'demurrage' && charge.chargeType.toLowerCase() === 'demurrage')
//         ).filter(charge =>
//             searchQuery ? (
//                 charge.chargeId.toLowerCase().includes(searchQuery.toLowerCase()) ||
//                 charge.shippingId.toLowerCase().includes(searchQuery.toLowerCase()) ||
//                 charge.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
//                 charge.chargeType.toLowerCase().includes(searchQuery.toLowerCase()) ||
//                 charge.amount.toString().includes(searchQuery) ||
//                 charge.dueDate.includes(searchQuery) ||
//                 charge.status.toLowerCase().includes(searchQuery.toLowerCase())
//             ) : true
//         );
//         setFilteredCharges(filteredCharges);
//         setCurrentPage(1);
//         if(onUpdateCount){
//             onUpdateCount(filteredCharges.length);
//         }
//     }, [ EstimatedCharge, searchQuery,onUpdateCount,activeTab]);


//     const indexOfLastCharge = currentPage * itemsPerPage;
//     const indexOfFirstCharge = indexOfLastCharge - itemsPerPage;
//     const currentCharges = filteredCharges.slice(indexOfFirstCharge, indexOfLastCharge);
//     const totalPages = Math.ceil(filteredCharges.length / itemsPerPage);



//     const formattedCharges = currentCharges.map(charge => {
//         const status = charge.status.toLowerCase();
//         return {
//             'Charge ID': charge.chargeId,
//             'Shipping ID': charge.shippingId,
//             'Description': charge.description,
//             'Charge Type': charge.chargeType,
//             'Amount': `$${charge.amount.toFixed(2)}`,
//             'Due Date': charge.dueDate,
//             'Status': (
//                 <span className={`py-1 px-3 rounded-full text-xs font-medium ${
//                     status === 'paid' ? 'bg-green-200 text-green-800' :
//                         status === 'unpaid' ? 'bg-red-200 text-red-800' :
//                             'bg-yellow-200 text-yellow-800'
//                 }`}>
//         {charge.status}
//       </span>
//             )
//         };
//     });


//     return (
//         <div className="bg-white p-4 rounded-xl shadow-md">
//             <div className="mb-4 flex gap-2">
//                 <Button
//                     text="Detention"
//                     backgroundColor={activeTab === 'detention' ? '#223688' : 'white'}
//                     textColor={activeTab === 'detention' ? 'white' : '#223688'}
//                     onClick={() => {
//                         setActiveTab('detention');
//                         setCurrentPage(1);
//                     }}
//                 />
//                 <Button
//                     text="Demurrage"
//                     backgroundColor={activeTab === 'demurrage' ? '#223688' : 'white'}
//                     textColor={activeTab === 'demurrage' ? 'white' : '#223688'}
//                     onClick={() => {
//                         setActiveTab('demurrage');
//                         setCurrentPage(1);
//                     }}
//                 />
//             </div>
//             <div className="overflow-y-auto max-h-96">
//             <Table headers={headers} data={formattedCharges}>
//   {(row) => (
//     <>
//       <td>{row["Charge ID"]}</td>
//       <td>{row["Shipping ID"]}</td>
//       <td>{row["Description"]}</td>
//       <td>{row["Charge Type"]}</td>
//       <td>{row["Amount"]}</td>
//       <td>{row["Due Date"]}</td>
//       <td>{row["Status"]}</td>
//     </>
//   )}
// </Table>

//             </div>
//             <GlobalPagination
//                 currentPage={currentPage}
//                 totalPages={totalPages}
//                 onPageChange={setCurrentPage}
//                 itemsPerPage={itemsPerPage}
//                 onItemsPerPageChange={setItemsPerPage}
//                 label="Estimated Charges Per page"
//             />
//         </div>
//     );
// };

// export default EstimatedChargesTab;

import React, { useState, useEffect,useRef } from "react";
import Table from "../../../../components/ACS-Dashboard/ACS-Blocks/Table";
import Button from "../../../../components/ACS-Dashboard/ACS-Blocks/Button";
import { MoreHorizontal } from "lucide-react";
import ActionMenu from "../../../../components/ACS-Dashboard/ACS-Blocks/ActionMenu";
import Loader from "../../../../components/ACS-Dashboard/ACS-Blocks/Loader";
import {
  useTableSavedViews,
  TableSavedViewsControl,
} from "../../../TableSavedViews";

// Extended sample data for detention and demurrage
const sampleEstimatedChargesData = [
  // // Detention entries (7 items)
  // { chargeId: 'C001', shippingId: 'SHP001', description: 'Container detention Fee', chargeType: 'detention', amount: 150, dueDate: '2025-02-25', status: 'Pending' },
  // { chargeId: 'C002', shippingId: 'SHP002', description: 'Container detention Fee', chargeType: 'detention', amount: 200, dueDate: '2025-03-01', status: 'Unpaid' },
  // { chargeId: 'C004', shippingId: 'SHP004', description: 'Container detention Fee', chargeType: 'detention', amount: 125, dueDate: '2025-03-10', status: 'Pending' },
  // { chargeId: 'C005', shippingId: 'SHP005', description: 'Container detention Fee - Weekend', chargeType: 'detention', amount: 180, dueDate: '2025-03-15', status: 'Paid' },
  // { chargeId: 'C006', shippingId: 'SHP006', description: 'Container detention Fee - Holiday', chargeType: 'detention', amount: 210, dueDate: '2025-03-20', status: 'Pending' },
  // { chargeId: 'C007', shippingId: 'SHP007', description: 'Container detention Fee - Peak Season', chargeType: 'detention', amount: 230, dueDate: '2025-03-25', status: 'Approved' },
  // { chargeId: 'C008', shippingId: 'SHP008', description: 'Container detention Fee - Off-peak', chargeType: 'detention', amount: 140, dueDate: '2025-03-28', status: 'Paid' },
  // // Demurrage entries (7 items)
  // { chargeId: 'D001', shippingId: 'SHP101', description: 'Container Demurrage Fee', chargeType: 'demurrage', amount: 175, dueDate: '2025-03-04', status: 'Paid' },
  // { chargeId: 'D002', shippingId: 'SHP102', description: 'Container Demurrage Fee - Extended', chargeType: 'demurrage', amount: 220, dueDate: '2025-03-08', status: 'Pending' },
  // { chargeId: 'D003', shippingId: 'SHP103', description: 'Container Demurrage Fee - Weekend', chargeType: 'demurrage', amount: 190, dueDate: '2025-03-12', status: 'Unpaid' },
  // { chargeId: 'D004', shippingId: 'SHP104', description: 'Container Demurrage Fee - Holiday', chargeType: 'demurrage', amount: 240, dueDate: '2025-03-18', status: 'Pending' },
  // { chargeId: 'D005', shippingId: 'SHP105', description: 'Container Demurrage Fee - Peak Season', chargeType: 'demurrage', amount: 260, dueDate: '2025-03-22', status: 'Approved' },
  // { chargeId: 'D006', shippingId: 'SHP106', description: 'Container Demurrage Fee - Off-peak', chargeType: 'demurrage', amount: 160, dueDate: '2025-03-26', status: 'Paid' },
  // { chargeId: 'D007', shippingId: 'SHP107', description: 'Container Demurrage Fee - Emergency', chargeType: 'demurrage', amount: 300, dueDate: '2025-03-30', status: 'Pending' }
];

const TABLE_HEADERS = [
  'Selection',
  'Action',
  'Charge ID',
  'Shipping ID',
  'Description',
  'Charge Type',
  'Amount',
  'Due Date',
  'Status',
  'Charge Code',
  'Charge Name',
  'Shipment Number'
];

const EstimatedChargesTab = ({ searchQuery, onUpdateCount, onRowClick }) => {
  const [activeTab, setActiveTab] = useState('detention');
  const [allCharges] = useState(sampleEstimatedChargesData);
  const [filteredCharges, setFilteredCharges] = useState([]);
  const [selected, setSelected] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [openMenu, setOpenMenu] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const menuRef = useRef(null);
  const checkboxHeaderRef = useRef(null);
  const bulkMenuRef = useRef(null);
  const [showBulkMenu, setShowBulkMenu] = useState(false);
  const [columnWidths, setColumnWidths] = useState({});

  const tableViews = useTableSavedViews({
    pageKey: "estimated-charges",
    allHeaders: TABLE_HEADERS,
    fixedPrefixCount: 2,
    defaultStickyColumnKeys: ["Selection", "Action", "Charge ID"],
  });

  const {
    dataHeaders,
    controlLabel,
    views,
    activeView,
    loading: viewsLoading,
    error: viewsError,
    isDirty,
    selectView,
    saveNewView,
    updateActiveView,
    renameView,
    deleteView,
    setDefaultView,
    updateColumnVisibility,
    columnManagerProps,
    onManageColumns,
  } = tableViews;

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutsideBulkMenu = (event) => {
      if (
        bulkMenuRef.current &&
        !bulkMenuRef.current.contains(event.target) &&
        checkboxHeaderRef.current &&
        !checkboxHeaderRef.current.contains(event.target)
      ) {
        setShowBulkMenu(false);
      }
    };
  
    document.addEventListener("mousedown", handleClickOutsideBulkMenu);
    return () => document.removeEventListener("mousedown", handleClickOutsideBulkMenu);
  }, []);

  // Filter and search
  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => {
      let list = allCharges.filter(ch => ch.chargeType === activeTab);
      if (searchQuery) {
        list = list.filter(ch =>
          Object.values(ch).some(val =>
            String(val).toLowerCase().includes(searchQuery.toLowerCase())
          )
        );
      }
      setFilteredCharges(list);
      setCurrentPage(1);
      if (onUpdateCount) onUpdateCount(list.length);
      setIsLoading(false);
    }, 500);
  }, [allCharges, activeTab, searchQuery, onUpdateCount]);

  // Selection handlers
  const handleSelectAll = checked => {
    setSelected(checked ? filteredCharges.map(ch => ch.chargeId) : []);
  };
  const handleSelectOne = id => {
    setSelected(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  // Pagination
  const start = (currentPage - 1) * itemsPerPage;
  const pageData = filteredCharges.slice(start, start + itemsPerPage);
  const totalPages = Math.ceil(filteredCharges.length / itemsPerPage);

  // Format rows
  const formatted = pageData.map(ch => {
    const statusKey = ch.status.toLowerCase();
    const statusClasses =
      statusKey === 'paid' ? 'bg-green-200 text-green-800' :
      statusKey === 'unpaid' ? 'bg-red-200 text-red-800' :
      'bg-yellow-200 text-yellow-800';
    const isDet = activeTab === 'detention';
    const code = isDet ? 'DET' : 'DEM';
    const nameDesc = isDet ? 'Detention' : 'Demurrage';

    return {
      'Charge ID': ch.chargeId,
      'Shipping ID': ch.shippingId,
      'Description': ch.description,
      'Charge Type': ch.chargeType,
      'Amount': `$${ch.amount.toFixed(2)}`,
      'Due Date': ch.dueDate,
      'Status': (
        <span className={`py-1 px-2 rounded-full text-xs font-medium ${statusClasses}`}>
          {ch.status}
        </span>
      ),
      'Charge Code': code,
      'Charge Name': nameDesc,
      'Shipment Number': ch.shippingId,
      _original: ch
    };
  });

  const renderActionColumn = (row, getStickyCellProps) => (
    <td
      className={`bg-white border-b border-gray-200 text-center ${
        openMenu === row['Charge ID'] ? "z-[301]" : "z-[200]"
      } ${getStickyCellProps("Action").className}`}
      style={{
        ...getStickyCellProps("Action").style,
        width: "50px",
        minWidth: "50px",
        maxWidth: "50px",
      }}
    >
      <div className="relative" ref={menuRef}>
        <button
          className="p-1 text-gray-500 hover:text-gray-800 relative w-full"
          onClick={(e) => {
            e.stopPropagation();
            setOpenMenu(openMenu === row['Charge ID'] ? null : row['Charge ID']);
          }}
        >
          <MoreHorizontal size={18} className="mx-auto" />
        </button>

        {openMenu === row['Charge ID'] && (
          <ActionMenu
            rowId={row['Charge ID']}
            isOpen
            moduleName="Charge"
            onClose={() => setOpenMenu(null)}
            actions={[
              {
                icon: "Eye",
                label: "View Details",
                color: "blue",
                action: () => onRowClick(row._original)
              },
              {
                icon: "FilePlus",
                label: "Create Invoice",
                color: "green",
                action: () => {}
              }
            ]}
          />
        )}
      </div>
    </td>
  );

  return (
    <div className="bg-white flex flex-col h-full">
      <div className="p-fluid-2">
        <div className="mb-fluid-1 flex gap-fluid-2">
          <Button
            text="Detention"
            backgroundColor={activeTab === 'detention' ? '#223688' : 'white'}
            textColor={activeTab === 'detention' ? 'white' : '#223688'}
            border="1px solid #223688"
            onClick={() => setActiveTab('detention')}
          />
          <Button
            text="Demurrage"
            backgroundColor={activeTab === 'demurrage' ? '#223688' : 'white'}
            textColor={activeTab === 'demurrage' ? 'white' : '#223688'}
            border="1px solid #223688"
            onClick={() => setActiveTab('demurrage')}
          />
        </div>
      </div>

      {isLoading ? (
        <Loader
          color="text-blue-600"
          size="h-5 w-5"
          message="Loading Estimated Charges...."
        />
      ) : (
        <>
          <div className="flex items-center justify-end gap-2 border-b border-gray-200 px-3 py-2 dark:border-acs-dark-border">
            <TableSavedViewsControl
              controlLabel={controlLabel}
              views={views}
              activeView={activeView}
              loading={viewsLoading}
              error={viewsError}
              isDirty={isDirty}
              allDataHeaders={TABLE_HEADERS.slice(2)}
              dataHeaders={dataHeaders}
              onSelectView={selectView}
              onSaveNew={saveNewView}
              onUpdateActive={updateActiveView}
              onRename={renameView}
              onDelete={deleteView}
              onSetDefault={setDefaultView}
              onUpdateColumnVisibility={updateColumnVisibility}
              onManageColumns={onManageColumns}
            />
          </div>
          <div className="flex-1 min-h-[200px] bg-white sm:min-h-[300px] overflow-x-auto">
            <Table
              {...columnManagerProps}
              data={formatted}
              onSelectAll={handleSelectAll}
              renderCheckboxActions={() => setShowBulkMenu(v => !v)}
              checkboxHeaderRef={checkboxHeaderRef}
              initialColumnWidths={columnWidths}
              onColumnResize={setColumnWidths}
              enableColumnResize
              enableColumnReorder
              enableColumnPin
            >
              {(row, _rowIdx, _columnWidths, getStickyCellProps, visibleColumns) => (
                <>
                  <td
                    className={`bg-white border-b border-gray-200 ${getStickyCellProps("Selection").className}`}
                    onDoubleClick={() => onRowClick(row._original)}
                    style={{
                      ...getStickyCellProps("Selection").style,
                      width: "80px",
                      minWidth: "80px",
                      maxWidth: "80px",
                    }}
                  >
                    <input
                      type="checkbox"
                      className="cursor-pointer mx-auto block"
                      checked={selected.includes(row['Charge ID'])}
                      onChange={() => handleSelectOne(row['Charge ID'])}
                    />
                  </td>

                  {renderActionColumn(row, getStickyCellProps)}

                  {((visibleColumns ?? []).map((col) => col.id).filter((id) => id !== "Selection" && id !== "Action").length
                    ? (visibleColumns ?? []).map((col) => col.id).filter((id) => id !== "Selection" && id !== "Action")
                    : dataHeaders
                  ).map((header) => (
                    <td
                      key={header}
                      className={`px-2 sm:px-3 py-1 sm:py-2 text-black text-xs sm:text-sm md:text-base border-b border-gray-200 ${getStickyCellProps(header).className}`}
                      onDoubleClick={() => onRowClick(row._original)}
                      style={{
                        ...getStickyCellProps(header).style,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        width: "200px"
                      }}
                    >
                      {row[header]}
                    </td>
                  ))}
                </>
              )}
            </Table>

            {showBulkMenu && checkboxHeaderRef.current && (
              <div
                ref={bulkMenuRef}
                className="absolute z-[1000]"
                style={{
                  top: checkboxHeaderRef.current.getBoundingClientRect().bottom + window.scrollY + 6,
                  left: checkboxHeaderRef.current.getBoundingClientRect().left + window.scrollX,
                }}
              >
                <ActionMenu
                  rowId="bulk"
                  isOpen={true}
                  onClose={() => setShowBulkMenu(false)}
                  moduleName="Charge"
                  placement="header"
                  actions={[
                    {
                      icon: "Check",
                      label: "Approve Selected",
                      color: "green",
                      action: () => {
                                                setShowBulkMenu(false);
                      },
                    },
                    {
                      icon: "FilePlus",
                      label: "Create Invoice",
                      color: "blue",
                      action: () => {
                                                setShowBulkMenu(false);
                      },
                    }
                  ]}
                />
              </div>
            )}
          </div>

          {/* Pagination */}
          <div className="flex justify-between border-t items-center bg-white p-fluid-1">
            <div className="flex items-center">
              <span className="mr-2">Charges per page</span>
              <select
                value={itemsPerPage}
                onChange={(e) => {
                  setItemsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
                className="border-b-2 border-black focus:outline-none"
              >
                {[10, 20, 50, 100].map((num) => (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex items-center">
              <button
                onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                disabled={currentPage === 1}
                className="mx-2 text-gray-500 disabled:opacity-50"
              >
                ❮
              </button>
              <span>
                {currentPage} of {totalPages}
              </span>
              <button
                onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                disabled={currentPage === totalPages}
                className="mx-2 text-gray-500 disabled:opacity-50"
              >
                ❯
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default EstimatedChargesTab;